import { useEffect } from "react";

/**
 * Zero-dependency SEO head manager for the SPA.
 * Sets document.title, meta description, canonical, Open Graph, Twitter
 * cards, and JSON-LD structured data for every route. Works with the
 * custom i18n (titles follow the active language via t()).
 */
const Seo = ({ title, description, type = "website", image, datePublished, slug }) => {
  useEffect(() => {
    const canonical = `https://zilouet.ai${slug ? `/post/${slug}` : window.location.pathname}`;
    const ogImage =
      image ||
      "https://images.ctfassets.net/ipfe10vbw2rl/logo/og-zilouet.png";

    document.title = title;

    const setMeta = (attr, key, value) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };

    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", canonical);
    setMeta("property", "og:image", ogImage);
    setMeta("property", "og:site_name", "Zilouet");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", ogImage);

    let canon = document.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.setAttribute("rel", "canonical");
      document.head.appendChild(canon);
    }
    canon.setAttribute("href", canonical);

    // JSON-LD structured data
    const ld = type === "article" && datePublished
      ? {
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          headline: title,
          description,
          image: [ogImage],
          datePublished,
          author: { "@type": "Organization", name: "Zilouet" },
          publisher: { "@type": "Organization", name: "Zilouet" },
          mainEntityOfPage: canonical,
        }
      : {
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: "Zilouet",
          url: canonical,
          description,
        };
    let ldEl = document.getElementById("seo-jsonld");
    if (!ldEl) {
      ldEl = document.createElement("script");
      ldEl.id = "seo-jsonld";
      ldEl.setAttribute("type", "application/ld+json");
      document.head.appendChild(ldEl);
    }
    ldEl.textContent = JSON.stringify(ld);
  }, [title, description, type, image, datePublished, slug]);

  return null;
};

export default Seo;
